"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  framerate: 24,
  images: [require('./sideSprite.png')],
  frames: [[1754, 2, 434, 811, 0, -19, 568], [2192, 2, 434, 811, 0, -19, 568], [2630, 2, 434, 811, 0, -19, 568], [3068, 2, 434, 811, 0, -19, 568], [2, 817, 434, 809, 0, -19, 567], [1316, 817, 434, 809, 0, -19, 567], [440, 817, 434, 809, 0, -19, 567], [1754, 817, 434, 809, 0, -19, 567], [3506, 2, 434, 809, 0, -19, 567], [878, 817, 434, 809, 0, -19, 567], [1316, 2, 434, 811, 0, -19, 568], [878, 2, 434, 811, 0, -19, 568], [440, 2, 434, 811, 0, -19, 568], [2, 2, 434, 811, 0, -19, 568]],
  animations: {
    idle2: {
      frames: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 6, 6, 7, 7, 7, 8, 8, 9, 9, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 0, 0, 0, 0],
      speed: 1
    },
    idle1: {
      frames: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 3, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      speed: 1
    },
    'talk loop': {
      frames: [10, 10, 10, 11, 11, 11, 12, 12, 12, 10, 10, 10, 12, 12, 12, 13, 13, 13, 11, 11, 11, 10, 10, 12, 12, 12, 10, 10, 10, 12, 12, 11, 11, 11, 10, 10, 10, 0, 0, 12, 12, 12, 11, 11, 11, 12, 12, 12, 12],
      speed: 1
    }
  }
};